import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });
api.interceptors.request.use((c) => { const m = actingAs(); if (m) c.headers["X-Act-As"] = m.id; return c; });

export function actingAs() { try { return JSON.parse(localStorage.getItem("nt-act-as") || "null"); } catch { return null; } }
export function setActingAs(m) { if (m) localStorage.setItem("nt-act-as", JSON.stringify({ id: m.id, name: m.name, patient_code: m.patient_code })); else localStorage.removeItem("nt-act-as"); window.location.assign("/patient"); }
export const withAct = (url) => { const m = actingAs(); return m ? `${url}${url.includes("?") ? "&" : "?"}act_as=${m.id}` : url; };

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => {
    const field = (x?.loc || []).slice(-1)[0];
    if (field === "email") return "Please enter a valid email address.";
    return x && typeof x.msg === "string" ? x.msg.replace("Value error, ", "") : JSON.stringify(x);
  }).join(" ");
  return d.msg || String(d);
}

export function useApi(path) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(Boolean(path));
  const load = useCallback(async () => {
    if (!path) return;
    setLoading(true);
    try {
      const r = await api.get(path);
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => { load(); }, [load]);
  return { data, error, loading, reload: load, setData };
}

export async function openSigned(path) {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(path);
    win.location = `${BACKEND}${data.url}`;
  } catch (e) {
    win.close();
    throw e;
  }
}

export const fileUrl = (path) => `${BACKEND}${path}`;

export async function downloadSigned(path) {
  const { data } = await api.get(path);
  const a = document.createElement("a");
  a.href = `${BACKEND}${data.url}?download=1`;
  document.body.appendChild(a); a.click(); a.remove();
}

const TZ = "Asia/Kolkata";
export const inr = (v) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(v || 0);
export const fmtDT = (s) => (s ? new Date(s).toLocaleString("en-IN", { timeZone: TZ, weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "-");
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" }) : "-");
export const fmtTime = (s) => (s ? new Date(s).toLocaleTimeString("en-IN", { timeZone: TZ, hour: "2-digit", minute: "2-digit" }) : "-");
export const istDay = (d) => d.toLocaleDateString("en-CA", { timeZone: TZ });
export const label = (s) => (s || "").replace(/_/g, " ");

export const mobile10 = (v) => { let d = (v || "").replace(/\D/g, ""); if (d.length > 10 && d.startsWith("91")) d = d.slice(2); if (d.startsWith("0")) d = d.slice(1); return d.slice(0, 10); };
